import {bigDataApi} from "../features/big_data/api/big_data_api";
import {kmApi} from "../features/km_app/api/km_api";
import {rpApi} from "../features/km_app/api/rp_api";
import {openStreetMapApi} from "../features/map/api/open_street_map_api";
import {userApi} from "../features/user/api/user_api";
import {rtkQueryErrorHandlerMiddleware} from "./middlewares/rtk_query_error_handler_middleware";

export const middleware = [
    rtkQueryErrorHandlerMiddleware,
    bigDataApi.middleware,
    kmApi.middleware,
    rpApi.middleware,
    userApi.middleware,
    openStreetMapApi.middleware
];
import {bigDataApi} from "../features/big_data/api/big_data_api";
import {kmApi} from "../features/km_app/api/km_api";
import {rpApi} from "../features/km_app/api/rp_api";
import {openStreetMapApi} from "../features/map/api/open_street_map_api";
import {userApi} from "../features/user/api/user_api";
import {rtkQueryErrorHandlerMiddleware} from "./middlewares/rtk_query_error_handler_middleware";

export const middleware = [
    rtkQueryErrorHandlerMiddleware,
    bigDataApi.middleware,
    kmApi.middleware,
    rpApi.middleware,
    userApi.middleware,
    openStreetMapApi.middleware
];
